import { useEffect, useMemo, useRef, useState } from 'react'
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { Card, Box, Autocomplete, TextField, Stack, Button, CircularProgress, Skeleton, Tooltip, Chip, MenuItem, Menu, } from '@mui/material'
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import GetAppOutlinedIcon from '@mui/icons-material/GetAppOutlined';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import { fetchLeaseBasicDetails, getAssetListApi, getLeaseSummryExport } from '../../shared_elements/actionCreators';
import { globalGetService } from '../../utils/globalApiServices';
import moment from 'moment';
import appConfig from '../../config';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import LeaseSummryExport from '../../shared_elements/components/LeaseSummryExport';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CostumLeaseSummary from '../../shared_elements/components/CustomLeaseSummaryExport';
import { handleExport } from '../../utils/exportFile';
import { checkApiStatus, getGlobalCookie } from '../../utils';
import { PageLoader } from "../../shared_elements";
import { enqueueSnackbar } from 'notistack';
import { trackActivity } from '../../utils/mixpanel';

const statusMap = {
        draft: {
            label: "Draft",
            color: "#89bfff",
            backgroundImage: "linear-gradient(90deg,#bedbfd,#dcebfc 95%)",
        },
        active: {
            label: "Active",
            color: "#5ec264",
            backgroundImage: "linear-gradient(90deg,#beed87,#d2e9b6 95%)",
        },
        closed: {
            label: "Closed",
            color: "#d32f2f",
            backgroundImage: "linear-gradient(269deg,#fcd5d5,#fca8a8 95%)",
        },
        terminated: {
            label: "Terminated",
            color: "#ff9800",
            backgroundImage: "linear-gradient(269deg,#fadfb8,#fdd79e 95%)",
        },
        "on-hold": {
            label: "On-hold",
            color: "#ee7c26",
            backgroundImage: "linear-gradient(269deg,#ffdfcb,#ffcdad 95%)",
        },
    };

const LeasesBasicDetails = () => {
    const { leaseSlug,asset_slug}  = useParams();
    const location=useLocation()
    const { assetList, leaseBasicDetails, summryList=[] } = useSelector((state) => state.leases);
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [isLoading, setLoading] = useState(false);
    const [isDropDownLoading, setIsDropDownLoading] = useState({ assetList: false });
    const [exportLoader,setExportLoader] = useState(false);
    const [leaseSummry, setLeaseSummry] = useState({ mode: '', modal: false, data: null });
    const [anchorEl, setAnchorEl] = useState(null);
    const hasHandledMissingAsset = useRef(false);
    const leaseDeletedRef = useRef(false);
    const params = useParams();
    const open = Boolean(anchorEl);
    const domain = appConfig.domain.subDomian;
    const oldValue = useRef(null);
    const assetTypeMap = {
        1: "aircraft",
        2: "engine",
        3: "apu",
        4: "landing_gear",
        5: "propeller",
        6: "fan",
        7: "hpc",
        8: "hpt",
        9: "lpt",
        10: "component"
    };
    const computedAsset = useMemo(() => {
        if (!assetList?.length) return null;
        if (asset_slug) {
            return assetList.find(asset => asset?.slug === asset_slug) || null;
        }
        if (leaseBasicDetails?.asset?.id) {
            return assetList.find(asset => asset?.slug === leaseBasicDetails?.asset?.slug) || null;
        }
        return null;
    }, [assetList, asset_slug, leaseBasicDetails]);
    const [selectedAsset, setSelectedAsset] = useState(computedAsset);
    useEffect(() => {
        setSelectedAsset(computedAsset)
    }, [computedAsset])

  useEffect(() => {
    const expectedAssetSlug = asset_slug || leaseBasicDetails?.asset?.slug;

    if (!assetList?.length || !expectedAssetSlug || hasHandledMissingAsset.current) {
      return;
    }

    if (computedAsset) {
      return;
    }

    hasHandledMissingAsset.current = true;
    enqueueSnackbar('Asset Not Available', { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" } });
    navigate('/leases', { replace: true });
  }, [assetList, asset_slug, leaseBasicDetails?.asset?.slug, navigate, computedAsset]);

  useEffect(() => {
    const leaseAssetIdFromState = location?.state?.asset?.id;
    const selectedAssetId = selectedAsset?.id;
    const shouldFetchLeaseDetails = leaseSlug && leaseSlug !== leaseBasicDetails?.slug;
    const assetIdMismatch = leaseSlug && leaseAssetIdFromState && String(leaseAssetIdFromState) !== String(selectedAssetId);

    if (shouldFetchLeaseDetails || assetIdMismatch) {
      setLoading(true);
      dispatch(fetchLeaseBasicDetails({ slug: leaseSlug, setLoading }));
    }
  }, [leaseSlug, location?.state?.asset]);

  useEffect(() => {
    if (!assetList?.length) {
      setIsDropDownLoading(prev => ({ ...prev, assetList: true }));
      dispatch(getAssetListApi({ setIsDropDownLoading, owners_lessees: false }));
    }
  }, []);

    useEffect(() => {
        if (!leaseSlug) return;
        leaseDeletedRef.current = false;
            if (leaseDeletedRef.current || document.hidden) return;
            globalGetService(`lease/${leaseSlug}/lease-details`)
                .then((response) => {
                    if (!checkApiStatus(response) && !leaseDeletedRef.current) {
                        leaseDeletedRef.current = true;
                        enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { horizontal: 'right', vertical: 'top' }, });
                        navigate('/leases', { replace: true });
                    }
                })
                .catch(() => {});
    }, [leaseSlug, navigate]);

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: 'Lease Basic Details', page_type: page_type })
    }

    const handleNavigate = (event, value) => {
        if (value) {
            // navigate(`/assets/1/${assetTypeMap[value?.asset_type]}/${value?.slug}/leases`)
            navigate(`/assets/${value?.asset_type}/${assetTypeMap[value?.asset_type]}/${value?.slug}/leases`)
            handleItemClicked(`Asset Selector Dropdown: ${value?.name}`);
        }
    }

    useEffect(() => {
        if(!summryList?.length) dispatch(getLeaseSummryExport({}, setLoading));
    }, []);

    const templateExport=(item,query={})=>{
        handleExport({
          URL: `lease/${params?.leaseSlug}/lease-summary/templates/export/${item?.template_slug}`,
          name: `${leaseBasicDetails?.asset?.name}_Lease` || 'LeaseSummary',
          docType: 'pdf',       
          setExportLoader: setExportLoader,
          query:query
        });
    }
    const getDurationInMonthsDays = (startDate, endDate) => {
        if (!startDate || !endDate) return "";
        const leaseStartDate = leaseBasicDetails?.start_date ? moment(leaseBasicDetails.start_date).startOf("day") : null;
        const start = leaseStartDate && leaseStartDate.isAfter(moment(startDate).startOf("day"))
            ? leaseStartDate
            : moment(startDate).startOf("day");
        const end = moment(endDate).startOf("day");

        if (!start.isValid() || !end.isValid()) return "";

        const months = end.diff(start, "months");
        const days = end.diff(start.clone().add(months, "months"), "days");

        const monthText = months
            ? `${months} Month${months !== 1 ? "s" : ""}`
            : "";

        const dayText = days
            ? `${days} Day${days !== 1 ? "s" : ""}`
            : "";

        return [monthText, dayText].filter(Boolean).join(" ") || "0 Day";
    };
    const isSameOperator = leaseBasicDetails?.operator?.id && leaseBasicDetails?.lessee?.id && String(leaseBasicDetails.operator.id) === String(leaseBasicDetails.lessee.id);
    
    return (
        <Box className="lease-basic-details-top">
            { isLoading  ? (
                <Card sx={{ display: { xs: 'none', sm: 'block' }, p: 1, height: "35px" }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Stack direction="row" spacing={2} sx={{ width: "50%" }}>
                            <Skeleton variant="rectangular" width="30%" />
                            <Stack direction="row" spacing={1}>
                                <Skeleton variant="rectangular" width={140} />
                                <Skeleton variant="rectangular" width={120} />
                            </Stack>
                        </Stack>
                        <Stack direction="row" spacing={4} paddingRight={3}>
                            {[...Array(5)]?.map((_, i) => (
                                <Stack key={i}>
                                    <Skeleton variant="text" width={80} />
                                    <Skeleton variant="text" width={100} />
                                </Stack>
                            ))}
                        </Stack>
                    </Box>
                </Card>
            ) : (
                    <Card className='top-card-style' sx={{display: { xs: 'none', sm: 'block', boxShadow: '0px 0px 2px 1px #B8B8B8' }}} elevation={0} >
                        <Box className='add-lease-dialog' sx={{ display: "flex", justifyContent:"space-between" }}>
                            <Stack  direction="row" spacing={1} sx={{ flex: 1, width: "50%"}}>
                                <Autocomplete
                                    className='lease-bascic-details-dropdown'
                                    disablePortal
                                    selectOnFocus={false}
                                    options={assetList || []}
                                    sx={{ width: { xs: '100%', md: params?.leaseSlug ? "32%" : "18%" } }}
                                    getOptionLabel={(option) => option?.name || ""}
                                    renderOption={(props, option) => ( <Box component="li" {...props} key={option.slug}> {option.name} </Box> )}
                                    noOptionsText={isDropDownLoading.assetList ? "loading" : "No Option Available"}
                                    value={selectedAsset}
                                    onChange={handleNavigate}
                                    isOptionEqualToValue={(option, value) => option.id === value.id}
                                    onOpen={() => {
                                        oldValue.current = selectedAsset;
                                        setSelectedAsset(null);
                                    }}
                                    onClose={(_, reason) => {
                                        if (reason !== 'selectOption') {
                                            setSelectedAsset(oldValue.current);
                                        }
                                    }}
                                    renderInput={(params) => (
                                        <Tooltip title={ selectedAsset ? selectedAsset?.lessor ? `${selectedAsset.name} (${selectedAsset.lessor})` : selectedAsset.name : "" }  arrow placement="bottom">
                                        <TextField
                                            {...params}
                                            margin='normal'
                                            size='small'
                                            sx={{
                                                height: "30px",
                                                '& .MuiOutlinedInput-root': { padding: 0, fontSize: '14px' },
                                                '& .MuiInputBase-input': {
                                                    padding: 0,
                                                    '@media (max-width:600px)': {
                                                        fontSize: '12px',
                                                    }
                                                },
                                            }}
                                            fullWidth
                                            slotProps={{
                                                className: 'lease-basic-details-dropdown-list',
                                                inputLabel: { shrink: true }, input: {
                                                    ...params?.InputProps, endAdornment: (<>{isDropDownLoading.assetList ? (<CircularProgress color="inherit" size={20} />) : null}
                                                        {params?.InputProps?.endAdornment}
                                                    </>)
                                                }
                                            }}
                                            placeholder={oldValue.current?.name || ""}
                                        /> </Tooltip>
                                    )}
                                />
                                    <Stack
                                        className='basic-details-btn-container'
                                        direction="row"
                                        spacing={{ md: 2, sm: 3 }}
                                        style={{ marginTop: "4px", marginLeft: "10px" }}
                                    >
                                        <Button
                                            className='basic-details-font '
                                            size='small'
                                            startIcon={<FlightTakeoffIcon size="small" />}
                                            disabled={!selectedAsset}
                                            onClick={() => {
                                                window.open(
                                                    `${domain}technical-specification/${assetTypeMap[selectedAsset?.asset_type]=== "landing_gear" ? "lg" :assetTypeMap[selectedAsset?.asset_type]
                                                    }/${selectedAsset?.slug}/basic-details`,
                                                    "_blank"
                                                );
                                                handleItemClicked('Technical Specification Button');
                                            }}
                                            sx={{ textTransform: 'none' }}
                                        >
                                            Technical Specification
                                        </Button>
                                    {!asset_slug && (
                                        <>
                                            <Button
                                                disableRipple
                                                className="basic-details-font"
                                                size="small"
                                                startIcon={<GetAppOutlinedIcon size="small" />}
                                                onClick={(e) => { setAnchorEl(e.currentTarget); handleItemClicked('Lease Summary Dropdown Button') }}
                                                templateExport={templateExport}
                                                sx={{ textTransform: 'none' }}
                                                endIcon={<ArrowDropDownIcon sx={{ transform: open ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.2s ease" }} fontSize="small" />}
                                            > Lease Summary </Button>
                                            <Menu
                                                sx={{ minWidth: "190px" }}
                                                anchorEl={anchorEl}
                                                open={open}
                                                onClose={() => setAnchorEl(null)}
                                                variant="menu"
                                                disableAutoFocusItem
                                                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                                transformOrigin={{ vertical: "top", horizontal: "left" }}
                                                transitionDuration={0}
                                                keepMounted
                                            >
                                                    <MenuItem
                                                        key={summryList[0]?.template_slug}
                                                        sx={{ fontSize: '13px' }}
                                                        onClick={() => {
                                                            setAnchorEl(null);
                                                            templateExport(summryList[0]);
                                                            handleItemClicked('Full Lease Summary MenuItem');
                                                        }}
                                                    > Full Lease Summary </MenuItem>
                                                <MenuItem
                                                    sx={{ fontSize: '13px' }}
                                                    onClick={() => { setAnchorEl(null); setLeaseSummry({ modal: true, data: summryList[0], mode: 'CUSTOM' }); handleItemClicked('Custom Lease Summary MenuItem'); }}
                                                > Custom Lease Summary </MenuItem>
                                                {/* <MenuItem
                                                        key={summryList[0]?.template_slug}
                                                        sx={{ fontSize: '13px' }}
                                                        onClick={() => {
                                                            setAnchorEl(null);
                                                            templateExport(summryList[0],{has_data:true});
                                                            handleItemClicked('Lease Summary with Data Field MenuItem');
                                                        }}
                                                    > Lease Summary with Data Field </MenuItem> */}
                                            </Menu>
                                        </>
                                    )}
                                    </Stack>
                            </Stack>
                            {params?.leaseSlug ?
                                <Stack className='basic-details-content' direction="row" spacing={2} paddingRight={1} sx={{ display:'flex', alignItems:'center' }} flexWrap="wrap">
                                    <Stack>
                                        <p className='header-top-style basic-details-font'>Ref Code</p>
                                        <p className='header-font-style basic-details-font'>{leaseBasicDetails?.reference_code?.length ? leaseBasicDetails?.reference_code?.length <= 17 ? leaseBasicDetails?.reference_code : <Box className="mui-text-field-lable-icon">{leaseBasicDetails?.reference_code?.substring(0, 17)}...<Tooltip title={leaseBasicDetails?.reference_code}><InfoOutlineIcon fontSize="18px" color='primary' cursor='pointer' /></Tooltip></Box> : "--"}</p>
                                    </Stack>
                                    {!isSameOperator && leaseBasicDetails?.operator && (
                                        <Stack>
                                            <p className='header-top-style basic-details-font'>Operator</p>
                                            <p className='header-font-style basic-details-font'>
                                                {leaseBasicDetails?.operator?.name?.length ? leaseBasicDetails?.operator?.name.length <= 15 ? leaseBasicDetails?.operator?.name : <Box className="mui-text-field-lable-icon">{leaseBasicDetails?.operator?.name?.substring(0, 15)}...<Tooltip title={leaseBasicDetails?.operator?.name}><InfoOutlineIcon fontSize="18px" color='primary' cursor='pointer' /></Tooltip></Box> : "--"}
                                            </p>
                                        </Stack>
                                    )}
                                    <Stack>
                                        <p className='header-top-style basic-details-font'>Lessor/Holdco</p>
                                        <p className='header-font-style basic-details-font'>
                                            {leaseBasicDetails?.lessor?.name?.length ? leaseBasicDetails?.lessor?.name.length <= 15 ? leaseBasicDetails?.lessor?.name : <Box className="mui-text-field-lable-icon">{leaseBasicDetails?.lessor?.name?.substring(0, 15)}...<Tooltip title={leaseBasicDetails?.lessor?.name}><InfoOutlineIcon fontSize="18px" color='primary' cursor='pointer' /></Tooltip></Box> : "--"}
                                        </p>
                                    </Stack>
                                    {/* <Stack>
                                        <p className='header-top-style basic-details-font '> Owner </p>
                                    <p className='header-font-style basic-details-font '> {leaseBasicDetails?.owner?.name?.length ? leaseBasicDetails?.owner?.name.length <= 15 ? leaseBasicDetails?.owner?.name : <Box className="mui-text-field-lable-icon">{leaseBasicDetails?.owner?.name?.substring(0, 15)}...<Tooltip title={leaseBasicDetails?.owner?.name}><InfoOutlineIcon fontSize="18px" color='primary' cursor='pointer' /></Tooltip></Box> : "--"} </p>
                                    </Stack> */}
                                    <Stack>
                                        <p className='header-top-style basic-details-font '> Lessee </p>
                                        <p className='header-font-style basic-details-font '> {leaseBasicDetails?.lessee?.name?.length ? leaseBasicDetails?.lessee?.name.length <= 15 ? leaseBasicDetails?.lessee?.name : <Box className="mui-text-field-lable-icon">{leaseBasicDetails?.lessee?.name?.substring(0, 15)}...<Tooltip title={leaseBasicDetails?.lessee?.name}><InfoOutlineIcon fontSize="18px" color='primary' cursor='pointer' /></Tooltip></Box> : "--"} </p>
                                    </Stack>
                                    <Stack>
                                        <p className='header-top-style basic-details-font'>Lease Start</p>
                                        <p className='header-font-style basic-details-font '>
                                            {moment(leaseBasicDetails?.start_date).format("DD MMM YYYY").toUpperCase()}
                                        </p>
                                    </Stack>
                                    <Stack>
                                        <p className='header-top-style basic-details-font'>Lease End</p>
                                        <p className='header-font-style basic-details-font '>
                                            {moment(leaseBasicDetails?.end_date).format("DD MMM YYYY").toUpperCase()}
                                        </p>
                                    </Stack>
                                    {leaseBasicDetails?.end_date && moment(leaseBasicDetails?.end_date).startOf("day").isAfter(moment().startOf("day")) ?
                                        <Stack>
                                            <p className='header-top-style basic-details-font '> Remaining Term </p>
                                            <p className='header-font-style basic-details-font '> {`${getDurationInMonthsDays(moment(), leaseBasicDetails?.end_date) || "--"}`} </p>
                                        </Stack> : null}
                                <Stack>
                                    <p className='header-top-style basic-details-font '> Status </p>
                                    <p className='header-font-style basic-details-font'>
                                        {(() => {
                                            const currentStatus = leaseBasicDetails?.status?.toLowerCase();
                                            const statusStyle = statusMap[currentStatus] || { label: leaseBasicDetails?.status || "--" };
                                            return (
                                                <Chip label={statusStyle.label} size="small" sx={{ height: '18px', padding: '0px 2px', color: statusStyle.color, background: statusStyle.backgroundImage, }} />
                                            );
                                        })()}
                                    </p>
                                </Stack>
                                </Stack> : null}
                        </Box>
                    </Card>
                )
            }
            {/* {leaseSummry.mode && leaseSummry.mode === "FULL" && (
                <LeaseSummryExport leaseSummry={leaseSummry} onToggleModal={() => setLeaseSummry({ modal: false, data: null, mode: '' })} />
            )} */}

            {leaseSummry.modal && leaseSummry.mode === 'CUSTOM' && (
                <CostumLeaseSummary leaseSummry={leaseSummry} onToggleModal={() => setLeaseSummry({ modal: false, data: null, mode: '' })} />
            )}
            {exportLoader? <PageLoader/>  :null }
        </Box>
    )
}

export default LeasesBasicDetails;
